import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { useI18next } from 'gatsby-plugin-react-i18next';

import * as styles from './style.module.scss';

const {
  successStory,
  successStory__image,
  successStory__link,
  successStory__text,
} = styles;

const queryString = graphql`
  query {
    allContentfulPageSuccessStory(sort: { createdAt: DESC }, limit: 20) {
      edges {
        node {
          title
          createdAt
          id
          language
          slug
          headerImage {
            title
            gatsbyImageData(width: 592, height: 311)
            description
          }
        }
      }
    }
  }
`;

const SuccessStoryCTA = ({ limit = 1 }) => {
  const { language } = useI18next();
  
  const data = useStaticQuery(queryString);
  
  const filtered = data.allContentfulPageSuccessStory.edges
  .filter(({ node }) => node.language === language);

  // Remove duplicates by slug
  const deduped = Array.from(
    new Map(filtered.map(({ node }) => [node.slug, node])).values()
  );

  const stories = deduped.slice(0, limit);


  return (
    <section className={successStory}>
      {stories.map((story, index) => (
        <a
          key={`${story.slug}-${index}`}
          href={`/customers/${story.slug}/`}
          className={successStory__link}
        >
          {index === 0 && (
            <GatsbyImage
              className={successStory__image}
              quality={100}
              image={getImage(story.headerImage)}
              alt={story.headerImage.description}
            />
          )}
          <p className={successStory__text}>{story.title}</p>
        </a>
      ))}
    </section>
  );
};

export default SuccessStoryCTA;
